// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__ZNFyr","label":"Category_label__1-ij3","content":"Category_content__WJl1c","header":"Category_header__1uXC1","location":"Category_location__1-OQk"};